import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AuditLogsAPI from '../../api/auditLogs';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    perPage: 25,
    totalEntries: 0,
  },
  filtersMeta: {
    actions: [],
    auditableTypes: [],
    users: [],
  },
  uiFlags: {
    fetchingList: false,
    exporting: false,
  },
};

const getters = {
  getAuditLogs(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getFiltersMeta(_state) {
    return _state.filtersMeta;
  },
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: true });
    try {
      const response = await AuditLogsAPI.get(params);
      const { audit_logs: logs = [], meta = {} } = response.data;
      commit(types.default.SET_AUDIT_LOGS, logs);
      commit(types.default.SET_AUDIT_LOGS_META, {
        totalEntries: meta.total,
        perPage: meta.per_page,
        currentPage: meta.current_page,
      });
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return logs;
    } catch (error) {
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },
  async fetchFiltersMeta({ commit }) {
    try {
      const response = await AuditLogsAPI.filtersMeta();
      const {
        actions: a = [],
        auditable_types: at = [],
        users = [],
      } = response.data;
      commit(types.default.SET_AUDIT_LOGS_FILTERS_META, {
        actions: a,
        auditableTypes: at,
        users,
      });
    } catch (_) {
      // silent
    }
  },
  async exportCsv({ commit }, params = {}) {
    commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { exporting: true });
    try {
      const response = await AuditLogsAPI.exportCsv(params);
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `audit_logs_${Date.now()}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { exporting: false });
    }
  },
};

const mutations = {
  [types.default.SET_AUDIT_LOGS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_AUDIT_LOGS]: MutationHelpers.set,
  [types.default.SET_AUDIT_LOGS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.default.SET_AUDIT_LOGS_FILTERS_META](_state, data) {
    _state.filtersMeta = { ..._state.filtersMeta, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
